import { TAGS } from "../constants";
import { QuestionOption, QuestionOptionInsert } from "../types";
import { api } from "./api";

export const questionOptionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getQuestionOptions: builder.query<
      { data: Omit<QuestionOption, "position">[]; count: number },
      { from: number; to: number; label?: string }
    >({
      query: (params) => ({
        method: "GET",
        url: `/api/question-options`,
        params,
      }),
      providesTags: [TAGS.QUESTION_OPTIONS],
    }),
    createQuestionOption: builder.mutation<
      Omit<QuestionOption, "position">,
      QuestionOptionInsert
    >({
      query: (body) => ({
        method: "POST",
        url: `/api/question-options`,
        body,
      }),
      invalidatesTags: [TAGS.QUESTION_OPTIONS],
    }),
  }),
});

export const { useGetQuestionOptionsQuery, useCreateQuestionOptionMutation } =
  questionOptionsApi;
